// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__months.hide-sunday .calendar__day:nth-of-type(7n) {\n  display: none;\n}\n.container__months.hide-sunday .calendar__day {\n  flex: 16.66%;\n}\n.container__months.hide-weekend .calendar__day:nth-of-type(7n),\n.container__months.hide-weekend .calendar__day:nth-of-type(7n-1) {\n  display: none;\n}\n.container__months.hide-weekend .calendar__day {\n  flex: 19%;\n}\n", ""]);
// Exports
module.exports = exports;
